<template>
    <v-content>
        <v-container grid-list-xs fluid class="app_container"
                     :style="{'background-image': 'url(' + background + ')'}">
            <v-layout fill-height column>
                <v-flex shrink aign-self-start class="area-logo">
                    <eco-logo :type="'light'"></eco-logo>
                </v-flex>
                <v-flex grow class="container_el main_body">
                    <v-layout fill-height>
                        <router-view></router-view>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>


<script>

    import background from "../../assets/background_default.jpg"
    import EcoLogo from "../../components/EcoLogo"
    import {getCustomerBackgoundUrl} from "../../helpers/location"


    export default {

        data: () => {
            return {
                background: background,
            }
        },
        created(){
            this.background =  getCustomerBackgoundUrl()
        },
        components: {
            EcoLogo
        }

    }
</script>


<style lang="scss">

    .app_container {
        height: 100%;
        width: 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;

        .main_body{
            //height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100vh - 140px);
        }
    }

    .area-logo {
        height: 100px;
        .container_logo {
            padding: 15px;

            .logo {
                margin: 0 auto;
                max-width: 140px;
            }
        }
    }


</style>
